import { validateResponseData } from '../utils';
import axiosInstance from '../utils/axiosInstance';
import { promotionsResponseSchema } from './schemas';

export const getPromotions = async () => {
  const response = await axiosInstance.get(`/promotions`);

  return validateResponseData(promotionsResponseSchema, response.data);
};
